import { render, staticRenderFns } from "./ThanksEmail.vue?vue&type=template&id=2058dc92&"
import script from "./ThanksEmail.vue?vue&type=script&lang=js&"
export * from "./ThanksEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports